"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    customerSubUnit: 'konsument' || 'customerSubUnit',
    setDeliveryRules: 'Sätt leveransregler' || 'setDeliveryRules',
    writeCustomerSubUnit: 'Skapa kund' || 'writeCustomerSubUnit',
    changeDeliveryDetails: 'Uppdatera leveransuppgifter' || 'changeDeliveryDetails',
    changeInvoiceDetails: 'Uppdatera fakturauppgifter' || 'changeInvoiceDetails',
    approveCustomerSubUnit: 'Godkänn kund' || 'approveCustomerSubUnit',
    blockCustomerSubUnit: 'Blocka kund från köp' || 'blockCustomerSubUnit',
    unblockCustomerSubUnit: 'Tillåt kund att köpa' || 'unblockCustomerSubUnit',
    approveAlcoholLicense: 'Godkänn alkoholtillstånd' || 'approveAlcoholLicense',
    revokeAlcoholLicense: 'Återkalla alkoholtillstånd' || 'revokeAlcoholLicense',
    setCustomerType: 'Sätt kundtyp' || 'setCustomerType',
    requestNewInvoiceInformation: 'Förfrågan att ändra faktureringsuppgifter' ||
        'requestNewInvoiceInformation',
    writeContact: 'Lägg till / ändra' || 'writeContact',
    writeContactAndInvite: 'Lägg till / ändra' || 'writeContactAndInvite',
    removeContact: 'Ta bort kontakt' || 'removeContact',
    setExternalCustomerNumber: 'Ange ert kundnummer' || 'setExternalCustomerNumber',
    markAsDuplicateOf: 'Markera som dubblett av' || 'markAsDuplicateOf',
    ensureInvariants: 'säkerställ invarianter' || 'ensureInvariants',
    connectToQvanti: 'Koppla till Qvanti' || 'connectToQvanti',
    disconnectFromQvanti: 'Koppla bort från Qvanti' || 'disconnectFromQvanti',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    customerNumber: 'Flaivys kundnummer' || 'customerNumber',
    currency: 'Valuta' || 'currency',
    supplier: 'Bunden till leverantör' || 'supplier',
    deliveryCountry: 'Land' || 'deliveryCountry',
    deliveryCountries: {
        SE: 'Sverige' || 'SE',
        FI: 'Finland' || 'FI',
        NO: 'Norge' || 'NO',
        DK: 'Danmark' || 'DK',
        IS: 'Island' || 'IS',
    },
    chain: 'Kedja' || 'chain',
    customerType: 'Kundtyp' || 'customerType',
    customerTypes: {
        horeca: 'HoReCa' || 'horeca',
        dvh: 'Dagligvaruhandel' || 'dvh',
        wholesale: 'Grossist' || 'wholesale',
        office: 'Kontor' || 'office',
        systembolaget: 'Systembolaget' || 'systembolaget',
        supplier: 'Leverantör till Flaivy' || 'supplier',
        export: 'Export' || 'export',
        other: 'Övrigt' || 'other',
    },
    name: 'Företagsnamn på faktura' || 'name',
    organisationNumber: 'Organisationsnummer' || 'organisationNumber',
    yourReference: 'Kundreferens' || 'yourReference',
    email: 'Kundens e-post (används för orderbekräftelse)' || 'email',
    phone: 'Telefon' || 'phone',
    termsOfPayment: 'Betalningsvillkor' || 'termsOfPayment',
    termsOfPayments: {
        0: '0 dagar' || '0',
        10: '10 dagar' || '10',
        15: '15 dagar' || '15',
        20: '20 dagar' || '20',
        30: '30 dagar' || '30',
        35: '35 dagar' || '35',
        60: '60 dagar' || '60',
        70: '70 dagar' || '70',
        A: 'Autogiro' || 'A',
        K: 'Kontant' || 'K',
        PF: 'Postförskott' || 'PF',
    },
    active: 'Aktiverad' || 'active',
    storeNumber: 'Butiksnummer' || 'storeNumber',
    GLN: 'GLN-nummer för fakturering' || 'GLN',
    invoiceDeliveryType: 'Fakturaleveranssätt' || 'invoiceDeliveryType',
    invoiceDeliveryTypes: {
        PRINT: 'Utskrift' || 'PRINT',
        EMAIL: 'E-post' || 'EMAIL',
        ELECTRONICINVOICE: 'E-faktura' || 'ELECTRONICINVOICE',
    },
    emailInvoice: 'E-post för faktura' || 'emailInvoice',
    invoiceAddress: 'Adress' || 'invoiceAddress',
    invoiceAddress2: 'Adress 2' || 'invoiceAddress2',
    invoiceZipCode: 'Postnummer' || 'invoiceZipCode',
    invoiceCity: 'Stad' || 'invoiceCity',
    approvedCustomer: 'Godkänd kund' || 'approvedCustomer',
    blocked: 'Kund har köpstopp' || 'blocked',
    blockedReason: 'Anledning till köpstopp' || 'blockedReason',
    isBlockedFromCampaigns: 'Kunden är blockad från att ta del av kampanjer' ||
        'isBlockedFromCampaigns',
    requiresGroupInvoice: 'Samlingsfaktura' || 'requiresGroupInvoice',
    invoiceCountry: 'Fakturaadress land' || 'invoiceCountry',
    invoiceCountries: {
        SE: 'Sverige' || 'SE',
        FI: 'Finland' || 'FI',
        NO: 'Norge' || 'NO',
        DK: 'Danmark' || 'DK',
        IS: 'Island' || 'IS',
    },
    deliveryName: 'Företagsnamn  (t.ex. &quot;Restaurang Morten&quot; el. &quot;ICA Nära&quot;)' ||
        'deliveryName',
    deliveryAddress: 'Adress' || 'deliveryAddress',
    deliveryAddress2: 'Adress 2' || 'deliveryAddress2',
    deliveryZipCode: 'Postnummer' || 'deliveryZipCode',
    deliveryCounty: 'Län' || 'deliveryCounty',
    deliveryCounties: {
        'SE-O': 'Västra Götaland' || 'SE-O',
        'SE-N': 'Halland' || 'SE-N',
        'SE-M': 'Skåne' || 'SE-M',
        'SE-K': 'Blekinge' || 'SE-K',
        'SE-I': 'Gotland' || 'SE-I',
        'SE-H': 'Kalmar' || 'SE-H',
        'SE-G': 'Kronoberg' || 'SE-G',
        'SE-F': 'Jönköping' || 'SE-F',
        'SE-E': 'Östergötland' || 'SE-E',
        'SE-D': 'Södermanland' || 'SE-D',
        'SE-C': 'Uppsala' || 'SE-C',
        'SE-Z': 'Jämtland' || 'SE-Z',
        'SE-Y': 'Västernorrland' || 'SE-Y',
        'SE-X': 'Gävleborg' || 'SE-X',
        'SE-W': 'Dalarna' || 'SE-W',
        'SE-BD': 'Norrbotten' || 'SE-BD',
        'SE-T': 'Örebro' || 'SE-T',
        'SE-S': 'Värmland' || 'SE-S',
        'SE-U': 'Västmanland' || 'SE-U',
        'SE-AC': 'Västerbotten' || 'SE-AC',
        'SE-AB': 'Stockholm' || 'SE-AB',
    },
    deliveryCity: 'Stad' || 'deliveryCity',
    deliveryPhone: 'Leveranstelefon' || 'deliveryPhone',
    deliveryGLN: 'GLN-nummer för leverans' || 'deliveryGLN',
    deliveryRules: 'Leveransregler' || 'deliveryRules',
    hasAlcoholPermit: 'Har bekräftat alkoholtillstånd' || 'hasAlcoholPermit',
    needSpecialHandling: 'Behöver specialhantering kring order' || 'needSpecialHandling',
    exciseNumber: 'Punktskattenummer (13 tecken)' || 'exciseNumber',
    taxWarehouseNumber: 'Skatteupplagsnummer (13 tecken)' || 'taxWarehouseNumber',
    restaurantNumber: 'Restaurangnummer (8 tecken)' || 'restaurantNumber',
    delphiCode: 'Kod i Delphiregistret' || 'delphiCode',
    qvantiId: 'Identitet i Qvanti' || 'qvantiId',
    nrOfContacts: 'Antal kontakter' || 'nrOfContacts',
    customerSubUnitContacts: {
        id: 'Identitet' || 'id',
        name: 'Kundreferens' || 'name',
        email: 'E-post' || 'email',
        phone: 'Telefon' || 'phone',
        owner: 'Ägande organisation' || 'owner',
    },
};
